import { Routes as creativeRoutes } from "../creatives";
import { Routes as commonRoutes } from "../index";
import { Routes as pixelRoutes } from "../pixels";
import { Routes as reportRoutes } from "../report";

export const Routes = (flags) => {
  return [...commonRoutes, ...creativeRoutes(flags), ...pixelRoutes(flags), ...reportRoutes(flags)];
};
